/* global createNotification */
import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { route } from 'ziggy'
import Http from '@/js/global/http'


export const useFavoriteSpecialistsStore = defineStore('FavoriteSpecialistsStore', () => {
    
    const favoriteSpecialists = ref(new Set())
    const loading = ref(true)

    const list = computed(() => {
        return Array.from(favoriteSpecialists.value)
    })

    const enabled = window.evp.user != null

    if (enabled) {
        Http.post(route('list-favorite-specialists'), {
            success: response => {
                favoriteSpecialists.value = new Set(response)
            },
            error: e => {
                console.log(e)
            },
            always: () => {
                loading.value = false
            }
        })
    }


    return {
        list,
        loading,
        enabled,

        includes(specialistCode) {
            return favoriteSpecialists.value.has(specialistCode)
        },

        async add(specialistCode) {
            favoriteSpecialists.value.add(specialistCode)

            const response = await Http.post(route('add-favorite-specialist'), {
                data: { specialistCode }
            })

            if (response.error) {
                favoriteSpecialists.value.delete(specialistCode)

                createNotification(response.error, 'warning')

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            }
        },

        remove(specialistCode) {
            favoriteSpecialists.value.delete(specialistCode)

            Http.post(route('remove-favorite-specialist'), {
                data: { specialistCode }
            })
        },
    }
})
